<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Contribution Towards to MAF</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <AutocompleteSingleAvatar
              @changeData="changeMembers($event)"
              :storeLink="'member/getClubMembersBySearch'"
              :setectVale="form.member_id"
              :itemText="'name'"
              :label="'Select member'"
            ></AutocompleteSingleAvatar>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date*'"
              v-model="form.date"
              :setectVale="form.date"
              @changeInput="form.date = $event"
            ></DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attached  Application Copy"
            ></v-file-input>
            <small>Max Size 500Kb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Attached payment slip"
            ></v-file-input>
            <small>Max Size 500Kb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.member_id"
              block
              @click="submit()"
              >Add Contribution</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-card class="pa-5 mt-5">
      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  Document1
                </th>
                <th class="text-left">
                  Document2
                </th>              
                <th class="text-left">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in details" :key="item.uuid">
               <td v-if="item.member_id">{{ item.member_id.display_name }}</td>
                <td>{{ item.date }}</td>
                <td v-if="item.documents.length > 0"><a :href="item.documents[0].path" target="_blank">Click hear</a></td>
                <td v-else>NA</td>
                <td v-if="item.documents.length > 1"><a :href="item.documents[1].path" target="_blank">Click hear</a></td>               
                <td v-else>NA</td>          
                <td><v-icon color="red" @click="deleteDetail(item.uuid)">
                mdi-delete-circle
            </v-icon></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import AutocompleteSingleAvatar from "@/components/shared/AutocompleteSingleAvatar";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "MafContribution",

  components: { Alert, Snackbars, DatePicker, AutocompleteSingleAvatar },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "Successfully added",
    uuid:localStorage.getItem("maf_contribution_uuid") || null,
    form: {
      member_id: "",
      date: null,
      document1: null,
      document2: null,
    },
    details: []
  }),

  mounted() {
    if(localStorage.getItem("maf_contribution_uuid")){
      this.getDetails(localStorage.getItem("maf_contribution_uuid"));
    }
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append("member_id", this.form.member_id);

      fd.append("date", this.form.date);
      fd.append("month", this.$route.params.month);
      fd.append("key", "MAF_CONTRIBUTION");

      let data = fd;
      ActivityService.submitActivity("maf-contribution-details", data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.uuid = response.data.data.uuid
            localStorage.setItem('maf_contribution_uuid', response.data.data.uuid);
            this.reset();
            this.snackbar = true;
            this.getDetails(response.data.data.uuid);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    changeMembers(value) {
      this.form.member_id = value;
    },

    getDetails(uuid){

      ActivityService.getActivityInfo("maf-contribution-details", uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
           this.details = response.data?.data?.details || []
          }
        })
        .catch((error) => {
          this.loading = false;
          this.details = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });

    },

    deleteDetail(uuid){
      ActivityService.deleteActivity("maf-contribution-details", uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
          this.getDetails(this.uuid);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.details = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.date = null;
      this.form.member_id = '';
      this.form.document1 = null;
      this.form.document2 = null;
    },
  },
};
</script>
